"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CalendarConfiguration {
    constructor(inputSettings) {
        this.numOfSelection = inputSettings.numOfSelection || 1;
        this.deviceType = 'default';
        this.deselectLastSlot = (this.numOfSelection > 1 ? false : true);
        this.allowDisabledSlotSelection = inputSettings.allowDisabledSlotSelection || false;
        this.numOfWeeksToShow = inputSettings.numOfWeeksToShow || 2;
        this.showWholeMonth = inputSettings.showWholeMonth || true;
        this.dateWindowSize = inputSettings.dateWindowSize || 7;
    }
}
exports.default = CalendarConfiguration;
